// extracted by css-extract-rspack-plugin
export default {"favoritesWrapper":"_7924bc6a","icon":"_8f442515","enlargedIcon":"_4c8a11e7","favoritesSpacing":"_94f58b38"};